var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewBIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.078125C12.3576 0.078125 5.42702 4.25937 0.312979 11.0508C-0.104326 11.6072 -0.104326 12.3846 0.312979 12.941C5.42702 19.7406 12.3576 23.9218 20 23.9218C27.6424 23.9218 34.573 19.7406 39.687 12.9491C40.1043 12.3927 40.1043 11.6154 39.687 11.059C34.573 4.25937 27.6424 0.078125 20 0.078125ZM20.5482 20.3952C15.4751 20.7143 11.2857 16.5331 11.6048 11.4518C11.8666 7.26233 15.2624 3.86661 19.4518 3.60477C24.5249 3.28565 28.7143 7.46689 28.3952 12.5482C28.1252 16.7294 24.7295 20.1252 20.5482 20.3952ZM20.2946 16.5167C17.5616 16.6885 15.3033 14.4384 15.4833 11.7054C15.6224 9.44705 17.4553 7.62236 19.7136 7.47508C22.4466 7.30325 24.7049 9.55342 24.5249 12.2864C24.3776 14.5529 22.5447 16.3776 20.2946 16.5167Z",
    fill: "#318BEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBIcon);
export default __webpack_public_path__ + "static/media/view-b-icon.d57a3bad04b0b66eda87a600d9757251.svg";
export { ForwardRef as ReactComponent };